import { Timestamp } from '@dixa/lib-shared-habla';
import { ampli } from 'lib-shared-tracking';

import { SubTitleRendererParams } from '../../subTitleRenderers';

export function sidebarSubTitleRenderer(params: SubTitleRendererParams) {
  const { metaConversation } = params;
  const { conversation } = metaConversation;
  const { last_message_created_at: lastMessageCreatedAt } = conversation;

  const separator = ' · ';
  const CSID = metaConversation.conversation.id;

  return (
    <>
      {CSID && <span>{`#${CSID}`}</span>}

      {lastMessageCreatedAt && (
        <>
          {separator}
          <span
            onClick={() =>
              ampli.conversationsTimestampClicked({
                context: 'created',
              })
            }
          >
            <Timestamp relative time={lastMessageCreatedAt} />
          </span>
        </>
      )}
    </>
  );
}
